import { FC } from "react";

import { ClassSessionCategory } from "components/server-types";
import { t } from "i18n/i18n";
import { Chip } from "mds/components/Chip";
import { useAppSelector } from "store/index";
import { selectClassSessionBySectionId } from "store/selectors";
import { useAv } from "utils/av";

export const SessionInProgressChip: FC<{ sectionId: string }> = ({ sectionId }) => {
  const { isAvSupportedInBrowser } = useAv();
  const classSession = useAppSelector((state) => selectClassSessionBySectionId(state, sectionId));

  if (
    !classSession?.category ||
    classSession?.is_practice ||
    (classSession?.category === ClassSessionCategory.VIRTUAL && !isAvSupportedInBrowser)
  ) {
    return null;
  }

  return <Chip kind="blue">{t("home.session_in_progress")}</Chip>;
};
